type Address = {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
};

export const formatAddress = (address: Address): string => {
  const { addressLine1, addressLine2, city, state, zip } = address;
  const cityStateZip = [city, state ? `${state}${zip ? ` ${zip}` : ""}` : zip].filter(Boolean).join(", ");
  return [addressLine1, addressLine2, cityStateZip].filter(Boolean).join(", ");
};

export const enumToItems = (enumObj: Record<string, string>) =>
  Object.values(enumObj).map((value) => ({
    id: value,
    title: convertReadableString(value),
  }));

export const toTitleCase = (str: string): string => str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

export const convertReadableString = (str: string | undefined | null): string => {
  if (!str) return "";
  return str
    .split("_")
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
    .join(" ");
};
